import { render, staticRenderFns } from "./AttributionStatus.vue?vue&type=template&id=bfde4abc"
import script from "./AttributionStatus.vue?vue&type=script&lang=js"
export * from "./AttributionStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfde4abc')) {
      api.createRecord('bfde4abc', component.options)
    } else {
      api.reload('bfde4abc', component.options)
    }
    module.hot.accept("./AttributionStatus.vue?vue&type=template&id=bfde4abc", function () {
      api.rerender('bfde4abc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/teacher/AttributionStatus.vue"
export default component.exports